<div class="min-h-screen flex items-center justify-center px-4 py-24">
  <!-- Loading State -->
  @if (isLoading) {
    <div class="w-full max-w-2xl">
      <app-galaxy-card padding="lg">
        <div galaxy-card-content class="text-center space-y-6 p-8">
          <app-galaxy-skeleton
            height="6rem"
            width="6rem"
            borderRadius="9999px"
            class="mx-auto"
          ></app-galaxy-skeleton>
          <app-galaxy-skeleton
            height="2rem"
            width="60%"
            class="mx-auto"
          ></app-galaxy-skeleton>
          <app-galaxy-skeleton
            height="1rem"
            width="80%"
            class="mx-auto"
          ></app-galaxy-skeleton>
          <app-galaxy-skeleton
            height="4rem"
            width="50%"
            borderRadius="9999px"
            class="mx-auto"
          ></app-galaxy-skeleton>
        </div>
      </app-galaxy-card>
    </div>
  }

  <!-- Content Wrapper for Success/Error States -->
  @if (!isLoading) {
    <div class="w-full max-w-2xl">
      <app-galaxy-card class="text-center animate-fade-slide-up" padding="lg">
        <div galaxy-card-content>
          <!-- Success State -->
          @if (paymentSuccessful) {
            <div>
              <!-- Neon Check Icon -->
              <div class="mb-6">
                <svg
                  class="w-24 h-24 text-cyan-400 mx-auto drop-shadow-neon-cyan"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <h1 class="text-4xl font-bold text-gray-100 mb-3">
                ¡Pedido confirmado!
              </h1>
              <p class="text-lg text-gray-300 mb-8">
                Gracias por tu compra. Hemos recibido tu pago.
              </p>
              <!-- Order ID -->
              <div
                class="bg-black/30 rounded-xl px-6 py-4 mb-8 inline-block border border-white/10"
              >
                <p class="text-sm text-violet-300 tracking-widest">ORDEN #</p>
                <p class="text-2xl font-mono text-gray-200 tracking-wider">
                  {{ orderId }}
                </p>
              </div>
              <p class="text-gray-400 mb-10 max-w-md mx-auto">
                Hemos enviado un recibo a tu correo. Puedes seguir el estado de
                tu pedido desde tu perfil.
              </p>
              <!-- Actions -->
              <div
                class="flex flex-col sm:flex-row justify-center items-center gap-4"
              >
                <button
                  (click)="navigateToOrderHistory()"
                  appGalaxyButton
                  galaxyVariant="primary"
                  galaxySize="md"
                  appGalaxyRipple
                >
                  Ver estado del pedido
                </button>
                <button
                  (click)="navigateToHome()"
                  appGalaxyButton
                  galaxyVariant="ghost"
                  galaxySize="md"
                >
                  Seguir comprando
                </button>
              </div>
            </div>
          }
          <!-- Error State -->
          @if (!paymentSuccessful) {
            <div>
              <h1 class="text-4xl font-bold text-red-500 mb-4">
                Error en el Pago
              </h1>
              <p class="text-lg text-gray-200 mb-8">{{ message }}</p>
              <button
                (click)="navigateToHome()"
                appGalaxyButton
                galaxyVariant="primary"
                galaxySize="md"
                appGalaxyRipple
                class="bg-red-600 hover:bg-red-700 shadow-red-500/50"
              >
                Volver al Inicio
              </button>
            </div>
          }
        </div>
      </app-galaxy-card>
    </div>
  }
</div>
